import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'
import type { Question } from '@/types/form'
import { ValidationSettings } from './ValidationSettings'

interface QuestionSettingsProps {
  question: Question
  onChange: (patch: Partial<Question['settings']>) => void
}

export function TextSettings({ question, onChange }: QuestionSettingsProps) {
  return (
    <div className="flex flex-col gap-4">
      {['SHORT_TEXT', 'LONG_TEXT'].includes(question.type) && (
        <div className="flex items-center justify-between gap-3 text-sm">
          <span>長文字模式</span>
          <Switch
            aria-label="長文字模式"
            checked={question.type === 'LONG_TEXT' || Boolean(question.settings.longText)}
            onCheckedChange={(longText) => onChange({ longText })}
          />
        </div>
      )}
      <div className="grid grid-cols-2 gap-3">
        <div className="flex flex-col gap-2">
          <Label>最少字元</Label>
          <Input
            type="number"
            value={question.settings.minLength ?? ''}
            onChange={(event) => onChange({ minLength: Number(event.target.value) })}
          />
        </div>
        <div className="flex flex-col gap-2">
          <Label>最多字元</Label>
          <Input
            type="number"
            value={question.settings.maxLength ?? ''}
            onChange={(event) => onChange({ maxLength: Number(event.target.value) })}
          />
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <Label>Placeholder</Label>
        <Input
          value={question.settings.placeholder ?? ''}
          onChange={(event) => onChange({ placeholder: event.target.value })}
        />
      </div>
      <ValidationSettings question={question} onChange={onChange} />
    </div>
  )
}
